import React from 'react';
/*
To import child routes, insert the following code:
import { <childComponent>Routes } from './components/<child-folder>';
*/

import { Route } from '@plasma/ui.application.router';

const PlantLayoutAreaDrawings = React.lazy(() => import('.'));

export const plantLayoutAreaDrawingsRoutes = [
  new Route({
    path: 'plant-layout-area-drawings',
    element: PlantLayoutAreaDrawings,
    children: [],
  }),
];
